export enum RelationType {
  BlockedBy = "BlockedBy",
  Blocking = "Blocking",
  SupplyTogether = "SupplyTogether",
  References = "References",
  ReferencedBy = "ReferencedBy"
}
